import SVG_Inject from '@iconfu/svg-inject';

class SVGInject {
  constructor() {
    this.images = Array.from(document.querySelectorAll('.js-svg-inject'));

    this.init();
  }

  init() {
    this.images.forEach(image => SVG_Inject(image));
  }
}

export default SVGInject;
